import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M13.2021 6.59083C14.266 7.2612 14.266 8.7388 13.2021 9.40917L4.78569 14.7127C3.59495 15.463 2 14.6562 2 13.3035V2.69646C2 1.34378 3.59495 0.536955 4.78569 1.28729L13.2021 6.59083Z" }, null, -1)
  ]))]))
}
export default { render: render }